import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as firebase from 'firebase';

import { CheckClockService } from '../../services/check-clock.service';
import { CheckClockLoadService } from '../../services/check-clock-load.service';
import { EmployeeService } from '../../services/employee.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';

import { FileUpload } from '../../file-upload.modal';
import { Utils } from '../../util';

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;
    getMessage(): string;
}

@Component({
    selector: 'app-create-check-clock',
    templateUrl: './create-check-clock.component.html',
    styleUrls: ['./create-check-clock.component.css', '../../app.component.css']
})

export class CreateCheckClockComponent implements OnInit {

    basePath = '/check_clock_load';

    selectedFile: any;
    nameSelectedFile = '';
    currentFile: FileUpload;
    flagFile = false;

    pickadateParams = Utils.pickadateParamsNoBlank();

    fromDate: any;
    toDate: any;
    fromInit: string;
    toInit: string;
    errorText = '';

    loadText = 0;
    flagProcess = false;

    gewfSubs: any;
    gpsSubs: any;

    maxDaysLoad: number;

    constructor(private router: Router,
                private checkClockLoadService: CheckClockLoadService,
                private checkClockService: CheckClockService,
                private employeeService: EmployeeService,
                private catalogsSettingsService: CatalogsSettingsService) {
        this.gpsSubs = this.catalogsSettingsService.getPayrollSettings('1').subscribe(payrollObj => {
            this.gpsSubs.unsubscribe();

            this.maxDaysLoad = payrollObj.maxDaysLoad;
        });

        const currentDate = new Date();
        this.toInit = currentDate.toISOString().substr(0, 10);
        this.toDate = this.toInit;

        currentDate.setDate(currentDate.getDate() - 6);
        this.fromInit = currentDate.toISOString().substr(0, 10);
        this.fromDate = this.fromInit;
    }

    ngOnInit() {

    }

    detectFile(event) {
        this.errorText = '';
        this.nameSelectedFile = '';
        this.flagFile = false;
        this.loadText = 0;

        if (event.target.files.item(0)) {
            this.selectedFile = event.target.files.item(0);

            const extensions = new Array('.dat', '.csv');

            const extension = (this.selectedFile.name.substring(this.selectedFile.name.lastIndexOf('.'))).toLowerCase();

            if (extensions.indexOf(extension) > -1) {
                this.errorText = '';
                this.flagFile = true;

                this.nameSelectedFile = ': ' + this.selectedFile.name;
            } else {
                this.errorText = 'Tipo de archivo incorrecto (archivos permitidos: csv o dat)';
            }
        }
    }

    changeDate() {
        this.errorText = '';
        this.loadText = 0;
    }

    uploadFile() {
        console.log(`uploadFile ->`, this.fromDate, this.toDate);
        if ((this.fromDate !== undefined && this.toDate !== undefined) && (this.fromDate !== '' && this.toDate !== '')) {
            const from = Utils.convertDatefromISOStringtoObject(this.fromDate);
            const to = Utils.convertDatefromISOStringtoObject(this.toDate);
            console.log(`uploadFile ->`, from, to);

            if (from <= to) {
                const diffDays = Math.floor((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));
                console.log(`uploadFile ->`, diffDays, this.maxDaysLoad);

                if (diffDays <= this.maxDaysLoad) {
                    this.loadText = 1;
                    this.flagProcess = true;

                    this.validateFile(this.selectedFile, this.fromDate, this.toDate, this.processFile, this);
                } else {
                    this.errorText = 'El número de días entre las fechas debe ser máximo de ' + this.maxDaysLoad + ' días';
                }
            } else {
                // this.toDate = this.toInit;
                // this.fromDate = this.fromInit;

                this.errorText = 'La fecha inicio debe ser menor o igual a la fecha fin';
            }
        } else {
            this.errorText = 'Introduzca la fecha inicio y fecha fin';
        }
    }

    validateFile(textFile, inDate, enDate, callbackMethod, referenceClass) {
        const reader  = new FileReader();
        const employeeRecords = [];

        reader.onload = function(event: FileReaderEvent) {
            const csv = event.target.result;

            const lines = csv.split(/\r\n|\n/);

            const initDate = Utils.convertDatefromStringtoObject(inDate + ' 00:00:00');
            const endDate = Utils.convertDatefromStringtoObject(enDate + ' 23:59:59');
            console.log(`validateFile ->`, initDate, endDate, lines.length);


            const employeesDatetime = [];

            let recordsNumber = 0;
            let employeesNumber = 0;

            for (let j = 0; j < lines.length; j++) {
                if (lines[j] !== '') {
                    const columns = lines[j].split(/\t/);

                    const iDatetime = Utils.convertDatefromStringtoObject(columns[1].trim());
                    console.log(`000, ${iDatetime}, ${initDate}, ${endDate}`);

                    if (iDatetime >= initDate && iDatetime <= endDate) {
                        const iFolio = parseInt(columns[0].trim());
                        const datetimeArray = columns[1].trim().split(' ');
                        const iDate = Utils.getDateWhitoutTime(datetimeArray[0] + ' 00:00:00');
                        const iTime = datetimeArray[1];
                        const iType = parseInt(columns[3].trim());

                        console.log('Validando : ' + iFolio);

                        if (employeesDatetime[iFolio] === undefined) {
                            employeesDatetime[iFolio] = [[iDatetime, iType, iDate, iTime]];
                            recordsNumber = recordsNumber + 1;
                            employeesNumber = employeesNumber + 1;
                        } else {
                            const prevDatetime = employeesDatetime[iFolio].slice(-1).pop()[0];

                            const diffSeconds = Math.floor((iDatetime.getTime() - prevDatetime.getTime()) / 1000);

                            if (diffSeconds > 60) {
                                employeesDatetime[iFolio].push([iDatetime, iType, iDate, iTime]);
                                recordsNumber = recordsNumber + 1;
                            }
                        }
                    }
                }
            }

            if (employeesNumber > 0) {
                referenceClass.gewfSubs = referenceClass.employeeService.getEmployeesWithFolio().subscribe(tempEmployees => {
                    referenceClass.gewfSubs.unsubscribe();

                    const employeesId = [];
                    const employeesFolio = [];

                    tempEmployees.forEach(item => {
                        employeesId.push(item.id$);
                        employeesFolio.push(parseInt(item.internalKey));
                    });

                    referenceClass.loadText = 2;

                    const loadData = {
                        initDate: initDate,
                        endDate: endDate,
                        recordsNumber: recordsNumber,
                        employeesNumber: employeesNumber,
                        employeeIds: employeesId,
                        employeeFolios: employeesFolio
                    };

                    callbackMethod(referenceClass, employeesDatetime, loadData);
                });
            } else {
                referenceClass.loadText = -1;
                referenceClass.flagProcess = false;
            }
        };

        reader.onerror = function(event) {
            console.log('Error al leer el archivo. Recarga la página e inténtalo nuevamente.');
        };

        reader.readAsText(textFile);
    }

    processFile(refClass, records, loadData) {
        if (records.length > 0) {
            refClass.currentFile = new FileUpload(refClass.selectedFile);

            // Process to Upload to Firebase
            const fileUpload = refClass.currentFile;
            const storageRef = firebase.storage().ref();
            const uploadTask = storageRef.child(`${refClass.basePath}/${fileUpload.file.name}`).put(fileUpload.file);

            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
                // const snapshotRef = snapshot as firebase.storage.UploadTaskSnapshot;
                // (snapshotRef.bytesTransferred / snapshotRef.totalBytes * 100);
            }, (error) => {
                console.log(error, 'Error al subir el archivo. Recarga la página e inténtalo nuevamente');
            }, () => {
                fileUpload.url = uploadTask.snapshot.downloadURL;
                fileUpload.name = fileUpload.file.name;

                refClass.loadText = 3;

                const currentDate = new Date();

                const checkClockLoadJson = {
                    active: 1,
                    createdAt: currentDate,
                    employeeNumber: loadData.employeesNumber,
                    loadDate: fileUpload.createdAt,
                    registerNumber: loadData.recordsNumber,
                    sinceDate: loadData.initDate,
                    untilDate: loadData.endDate,
                    updatedAt: currentDate,
                    fileName: fileUpload.name,
                    fileUrl: fileUpload.url
                };

                refClass.checkClockLoadService.postCheckClockLoad(checkClockLoadJson).then(res => {
                    console.log('Load');
                    let iRecord = 0;
                    let recordsToBatch = [];
                    const batchs = [];

                    for (let item in records) {
                        console.log('Load');
                        console.log('Process : ' + item);
                        const position = loadData.employeeFolios.indexOf(parseInt(item));

                        for (let i = 0; i < records[item].length; i++) {
                            iRecord = iRecord + 1;

                            if (iRecord <= 500) {
                                const checkClockJson = {
                                    active: 1,
                                    checkClockLoadId: res,
                                    createdAt: currentDate,
                                    employeeId: (position === -1) ? '' : loadData.employeeIds[position],
                                    folio: parseInt(item),
                                    registrationDatetime: records[item][i][0],
                                    registrationDate: records[item][i][2],
                                    registrationTime: records[item][i][3],
                                    type: records[item][i][1],
                                    updatedAt: currentDate
                                };

                                recordsToBatch.push(checkClockJson);
                            }

                            if (iRecord === 500) {
                                batchs.push(recordsToBatch);

                                recordsToBatch = [];
                                iRecord = 0;
                            }
                        }
                    }

                    if (recordsToBatch.length > 0) {
                        batchs.push(recordsToBatch);
                    }

                    let batchCont = 0;

                    batchs.forEach(item => {
                        Promise.resolve(refClass.checkClockService.postCheckClockAtomic(item).then(function() {
                        })).then(function() {
                            batchCont = batchCont + 1;
                            console.log(batchCont);

                            if (batchCont === batchs.length) {
                                console.log('End');
                                refClass.loadText = 4;
                                refClass.flagProcess = false;
                            }
                        });
                    });
                });
            });
        }
    }
}
